import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/ServiceCenter/ServiceCenterMonitoring.requests'
import {
    ProductMetricsType,
} from '../serviceCenters.types'

const useGetProductMetrics = (id: number) => {
    return useRequest<{productMetrics: ProductMetricsType[]}>({
        key: RequestKeys.getProductMetrics,
        params: {
            serviceCenterId: id,
        },
        requestFunc: RequestFn.getEntity(requests.getProductMetrics),
        enabled: Boolean(id),
    })
}

export default useGetProductMetrics
